import InterviewConfigHeader from "./InterviewConfigHeader";
import InterviewConfigMain from "./InterviewConfigMain";
import "./Style.css";


const InterviewConfigTab = () => {
  return (
    <>
      <InterviewConfigHeader  />
      <InterviewConfigMain/>
    </>
  );
};

export default InterviewConfigTab;
